import React from 'react'
import { Button, Menu } from '@CommonComponents/buttons'

const filetypeIcons = {
  pdf: 'fa-file-pdf',
  txt: 'fa-text',
  doc: 'fa-file-word',
  docx: 'fa-file-word',
}

export function App({ transcripts, fileref }) {
  return (
    <div className="my-2 pull-right">
      <Menu
        id={`dropdown-basic-${fileref}`}
        label="Download format options"
        valueLabel="Transcripts"
        align="end"
        className="me-btn me-btn-secondary me-btn-sm me-btn-menu-trigger"
        download
      >
        {transcripts.map(({ file_type: filetype, title }) => (
          <Button
            key={`${fileref}-${filetype}`}
            href={`/account/transcripts.download/${fileref}/${filetype}/${title}`}
            className="me-menu-item transcript_download_item"
            aria-label={`Download transcript as ${filetype}`}
            download
            icon={`fa-light ${filetypeIcons[filetype]}`}
            iconAfter="fa-light fa-arrow-to-bottom"
          >
            {filetype.toUpperCase()}
          </Button>
        ))}
      </Menu>
    </div>
  )
}
